import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import styles from './VersionHistorySidebar.module.css';
import VersionHistoryCard from './Components/VersionHistoryCard';
import { DocumentVersion } from 'dataTypes/document';
import CircularProgress from '@mui/material/CircularProgress';
import { versionDate } from 'utils/formatDate';

export interface VersionHistorySidebarProps {
  documentId: number | undefined;
  isLoading: boolean;
  versions?: DocumentVersion[];
  isTemplate: boolean;
}

export default function VersionHistorySidebar({
  documentId,
  isLoading,
  versions,
  isTemplate,
}: VersionHistorySidebarProps) {
  /* 
  TODO: This shoud be refactored.
  ! This is a bad practice.
  * https://dev.to/igor_bykov/react-calling-functional-components-as-functions-1d3l
  */
  const renderVersions = () => {
    if (isLoading) {
      return (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      );
    }

    if (!versions?.length) {
      return (
        <Grid item xs={12}>
          <Typography className={styles.subtitle}>No versions created</Typography>
        </Grid>
      );
    }
    return versions?.map(versions => (
      <Grid item xs={12} key={versions.version}>
        <VersionHistoryCard
          createdAt={versionDate(versions.createdAt)}
          documentId={documentId}
          id={versions.id}
          key={versions.version}
          name={versions.name}
          isTemplate={isTemplate}
          updatedBy={versions.updatedBy}
        />
      </Grid>
    ));
  };

  return (
    //TODO This Box makes the sidebar look correctly while being mounted on the BuilderLayout.
    <Box>
      <Grid container direction='column' className={styles.container}>
        <Grid item xs={12}>
          <Typography className={styles.title}>Version History</Typography>
        </Grid>
        {renderVersions()}
      </Grid>
    </Box>
  );
}

